import { getQueryParams, setLocation } from 'utils/wrappers';
import { showError } from 'utils/messages';
import Base from 'app/views/base';

import CanadaPostRegistration from 'app/models/canada_post_registration';

import tmpl from 'templates/canada_post_account_callback_page';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    const queryParams = getQueryParams();

    this.model = new CanadaPostRegistration({
      'token-id': queryParams['token-id'],
      'registration-status': queryParams['registration-status'],
    });

    this.model.save({}, {
      success() {
        setLocation('/account/carriers');
      },
      error() {
        showError('There was an error communicating with CanadaPost, please try again later');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/canada_post_account_callback_page.js